import React from "react";

// Model
import { pages } from "./model/data";

// Styles
import "./style/App.scss";

// Theme
import { createTheme, ThemeProvider } from "@mui/material/styles";

// Component
import MenuBar from "./components/MenuBar/MenuBar";

const themeStyle = createTheme({
  typography: {
    p: {
      fontFamily: "Amalfi Coast, sans-serif",
      color: "#524C47",
    },
    h1: {
      fontSize: "4em",
      fontFamily: "Amalfi Coast, serif",
      color: "#524C47",
    },
    h2: {
      fontFamily: "Cormorant Medium, sans-serif",
      fontSize: "5.5em",
      color: "#524C47",
    },
    h5: {
      fontFamily: "Cormorant Medium, sans-serif",
      fontSize: "2.5em",
      color: "#524C47",
      margin: "30px 0",
    },
    h6: {
      fontFamily: "Cormorant Medium, sans-serif",
      fontSize: "2em",
      color: "#524C47",
    },
  },
});

const App = () => {
  return (
    <ThemeProvider theme={themeStyle}>
      <MenuBar />
      {[...pages].map((page) => {
        page = page.replaceAll(/\s/g, "");
        const Component = require(`./components/${page}/${page}`).default;
        const id = page.toLocaleLowerCase();
        return <Component id={id} key={id} />;
      })}
    </ThemeProvider>
  );
};

export default App;
